export default "__VITE_ASSET__D2oc$Yku__"